import Vue from 'vue'
import VueRouter from 'vue-router'

import INDEX from '@/pages/index'
import Main from '@/pages/Main'
import ProductionPage from '@/pages/others/ProductionPage'
import CommercialPage from '@/pages/others/CommercialPage'
import EnterprisePage from '@/pages/others/EnterprisePage'
import NewsPage from '@/pages/others/NewsPage'
import ProfitModel from '@/components/commercial/profit/ProfitModel'
import Stations from '@/pages/others/Stations'

Vue.use(VueRouter)
const descriptions = '中科院旗下品牌致力于电动汽车充电桩产品的创新、研发、生产销售。【主营】充电桩、汽车充电桩、新能源充电桩、电动汽车充电桩是专业的充电桩厂家。热线:400-8355708'
const keywords = '充电桩-充电站-汽车充电桩代理-汽车充电桩加盟-汽车充电站加盟-汽车直流充电桩-汽车智能充电桩-充电桩厂家' +
  '-储能-光储充-新能源-微电网-充电桩-充电桩加盟-中科全速-中科全速充电桩-汽车充电桩充电站-充电桩代理-充电桩加盟代理'
const routes = [
  {
    path: '/',
    name: 'INDEX',
    component: INDEX,
    redirect: '/index'
  },
  {
    path: '/index',
    name: '主页',
    component: Main,
    meta: {
      metaInfo: {
        title: '主页',
        meta: [
          { charset: 'utf-8' },
          { name: 'viewport', content: 'width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=1,user-scalable=no' },
          { name: 'description', content: descriptions },
          { name: 'keywords', content: keywords }
        ]
      }
    }
  },
  {
    path: '/about',
    name: '关于我们',
    component: EnterprisePage,
    meta: {
      metaInfo: {
        title: '关于我们',
        meta: [
          { charset: 'utf-8' },
          { name: 'viewport', content: 'width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=1,user-scalable=no' },
          { name: 'description', content: descriptions },
          { name: 'keywords', content: keywords }
        ]
      }
    }
  },
  {
    path: '/business',
    name: '招商加盟',
    component: CommercialPage,
    children: [
      {
        path: '/business/profit',
        name: 'ProfitModel',
        component: ProfitModel
      }
    ],
    meta: {
      metaInfo: {
        title: '招商加盟',
        meta: [
          { charset: 'utf-8' },
          { name: 'viewport', content: 'width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=1,user-scalable=no' },
          { name: 'description', content: descriptions },
          { name: 'keywords', content: keywords }
        ]
      }
    }
  },
  {
    path: '/production',
    name: '产品',
    component: ProductionPage,
    meta: {
      metaInfo: {
        title: '最新产品',
        meta: [
          { charset: 'utf-8' },
          { name: 'viewport', content: 'width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=1,user-scalable=no' },
          { name: 'description', content: descriptions },
          { name: 'keywords', content: keywords }
        ]
      }
    }
  },
  {
    path: '/news',
    name: '新闻',
    component: NewsPage,
    meta: {
      metaInfo: {
        title: '新闻页面',
        meta: [
          { charset: 'utf-8' },
          { name: 'viewport', content: 'width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=1,user-scalable=no' },
          { name: 'description', content: descriptions },
          { name: 'keywords', content: '公司新闻-行业动态-新能源政策-电气技术发展-建站补贴' }
        ]
      }
    }
  },
  {
    path: '/stations',
    name: '运营中心',
    component: Stations
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  // base: "/",
  routes,
  // 改变路由显示顶部
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return {
      x: 0,
      y: 0
    }
  }
})
router.afterEach((to) => {
  document.title = to.name
})
export default router
